<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $t("signagemoviemapping") }}
      </div>
      <router-link class="btn-blue" to="signage-mapping"
        >{{ $t("signagemoviemapping") }} {{ $tc("list") }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.Signage.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("signage", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="buttondisable"
                :text="selected.Signage"
                variant="dropdown-curve"
                class="w-100"
                v-b-tooltip.hover.top="$t('signage_type_tooltip')"
              >
                <b-dropdown-item
                  v-for="(signage, signageIndex) in Signages"
                  :key="signageIndex"
                  @click="onSelectHandler(signage, 'Signage')"
                  name="selectsignage"
                  id="selectsignage"
                  >{{ signage.st_name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('signage_type_tooltip')" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.Signage.length == 0"
                >Please Select Signage.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                Selectedsignagetype && Selectedsignagetype.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $tc("signage", 1) }}
              {{ $t("type") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="buttondisable"
                :text="Selectedsignagetype"
                variant="dropdown-curve"
                class="w-100"
                v-b-tooltip.hover.top="$t('signage_tooltip')"
              >
                <b-dropdown-item
                  v-for="(type, typeIndex) in SignageType"
                  :key="typeIndex"
                  @click="onSelectHandler(type, 'SignageType')"
                  >{{ type.name }}</b-dropdown-item
                >
              </b-dropdown>
              <!-- <Tooltip :title="$t('signage_tooltip')" /> -->
            </div>
            <p class="error_message">
              <span
                v-if="
                  submitted &&
                  Selectedsignagetype &&
                  Selectedsignagetype.length == 0
                "
                >Please Select Signage Type</span
              >
            </p>
          </div>
        </div>

        <div v-if="Selectedsignagetype == 'FnB'" class="col-lg-6 col-xl-4">
          <div class="d-flex align-items-center">
            <custommultiselect
              v-model="SelectedFnbItems"
              :options="FnbItemList"
              placeholder="Select Food and Beverages"
              label="item_name"
              :multiple="true"
              track-by="item_id"
              @remove="toggleUnSelectFnB"
            ></custommultiselect>
            <img
              src="@/assets/img/icons/question.svg"
              height="20"
              width="20"
              class="ml-2"
              v-b-tooltip.hover
            />
          </div>
          <p class="error_message">
            <span v-if="submitted && SelectedFnbItems.length == 0"
              >Please Select at least One Food and Beverages</span
            >
          </p>
        </div>

        <div v-if="Selectedsignagetype == 'Movie'" class="col-lg-6 col-xl-4">
          <div class="d-flex align-items-center">
            <custommultiselect
              v-model="Movie"
              :options="Movielist"
              placeholder="Select Movies"
              label="movie"
              :multiple="true"
              track-by="movie_id"
              @remove="toggleUnSelectMovie"
            ></custommultiselect>
            <img
              src="@/assets/img/icons/question.svg"
              height="20"
              width="20"
              class="ml-2"
              v-b-tooltip.hover
            />
          </div>
          <p class="error_message">
            <span v-if="submitted && Movie.length == 0"
              >Please Select at least One Movie</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  v-model="smm_is_active"
                  switch
                  class="j-checkbox"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>
      </div>

      <div
        v-if="Selectedsignagetype == 'Generic'"
        v-for="(item, index) in Url"
        :key="index"
        class="row"
      >
        <div class="col-3 mb-4 pr-0">
          <label class="material-file-upload">
            <!-- v-on:change="onFileUpload($event,PosterItem,PosterIndex,MovieContentIndex)" -->
            <input
              type="file"
              accept="video/*,image/*"
              v-on:change="setImage($event, index)"
              name="image"
              :id="'image' + index"
            />
            <div
              class="label"
              v-bind:class="{
                'shift-up': item.selected_url && item.selected_url.length > 0,
              }"
            >
              <div class="text-truncate">Upload Image | Video</div>
            </div>
            <div class="uploaded-file-name">
              <div class="text-truncate pt-2">{{ item.selected_url }}</div>
            </div>
          </label>
          <div v-if="item.uploadPercentage != 0">
            <div class="row">
              <div class="col-10 pl-4 pt-2 pr-1">
                <!-- <progress max="100" class="w-100" :class="item.uploadPercentage == 100 ? 'bg-success': ''" :value="item.uploadPercentage"></progress> -->
                <div class="progress" style="height: 0.5rem">
                  <div
                    class="progress-bar progress-bar-striped"
                    :class="item.uploadPercentage == 100 ? 'bg-success' : ''"
                    role="progressbar"
                    v-bind:style="{ width: item.uploadPercentage + '%' }"
                    :aria-valuenow="item.uploadPercentage"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              </div>
              <div class="col-2 p-0" style="font-size: 13px">
                {{ item.uploadPercentage + "%" }}
              </div>
            </div>
          </div>
        </div>
        <p class="error_message">
          <span
            v-if="
              submitted && item.selected_url && item.selected_url.length == 0
            "
            >Please Select an Image.</span
          >
        </p>
        <div class="col-1 mb-4">
          <img
            v-if="item.selected_url.length > 0 && item.selected_type == 'image'"
            :src="_GetImagePath(item.selected_url)"
            @click="
              openImageModal('Image', item.selected_url, item.selected_type)
            "
            height="38"
            width="38"
            class="rounded c-pointer"
          />
          <img
            v-else-if="
              item.selected_url.length > 0 && item.selected_type == 'video'
            "
            src="@/assets/img/icons/play.svg"
            @click="
              openImageModal('Video', item.selected_url, item.selected_type)
            "
            height="38"
            width="38"
            class="rounded c-pointer"
          />
          <img
            v-else
            src="@/assets/img/icons/empty-image.svg"
            height="35"
            width="35"
            class="rounded"
          />
        </div>
        <div class="col-3 mb-4 pl-1">
          <button
            v-if="index == 0"
            @click.prevent.stop="addGeneric()"
            class="btn-transparent"
          >
            <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
          </button>
          <button
            v-else
            @click.prevent.stop="removeGeneric(item, index)"
            class="btn-transparent"
          >
            <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="signage-mapping"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>

    <!-- Thumbnail IMAGE Crop MODAL -->
    <b-modal id="imagecropper" hide-header hide-footer no-close-on-backdrop>
      <div
        class="w-100 d-flex align-items-center justify-content-between mt-2 mb-4"
      >
        <label class="h4 text-center mb-0">Crop Image</label>
        <button
          class="btn-clearDate text-right"
          v-on:click="hideCropperModal('imagecropper')"
        >
          ✖
        </button>
      </div>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <div class="w-100 d-flex justif-content-center">
        <button class="btn-blue mx-auto" @click.prevent.stop="cropImage">
          Save
        </button>
      </div>
    </b-modal>

    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ tempModalImageName }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <img
        :src="_GetImagePath(tempModalImagePath)"
        v-if="tempContentType == 'image'"
        class="img-fluid"
      />
      <video
        autoplay
        :src="_GetImagePath(tempModalImagePath)"
        v-if="tempContentType == 'video'"
        class="img-fluid"
      />
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnBService from "@/services/Pos_Fnb_Service";
import signageServices from "@/services/signageService";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  components: { VueCropper },
  data() {
    return {
      buttondisable: true,
      btenable: false,
      selected: {
        Signage: "",
      },
      // v-validate="'required|email'"
      submitted: false,
      Signages: [],
      Movielist: [],
      Movie: [],
      smm_id: null,
      signage_type_id: null,
      smm_is_active: true,

      SignageType: [
        { id: 0, name: "Movie" },
        { id: 1, name: "FnB" },
        { id: 2, name: "Generic" },
      ],
      Selectedsignagetype: "",
      FnbItemList: [],
      SelectedFnbItems: [],
      cineID: null,
      Url: [],
      file: "",
      imgSrc: "",
      cropImg: "",
      filename: "",
      indexofthubmnail: "",
      tempModalImageName: null,
      tempModalImagePath: null,
      load: this.$loading.show(),
      tempContentType: "",
      currentmovie_id: [],
      removedmovie_id: [],
    };
  },
  beforeMount() {
    const { smm_id, signage_type_id } = this.$route.query;
    this.cineID = this.secureStore.get("USINFO").cinema_id;

    this.getSignageList();
    this.getMovieList();
    this.GetFnbItems();
    this.getSignageMovieMappingBYID(smm_id, signage_type_id);
  },
  methods: {
    getSignageMovieMappingBYID: function (id, signage_type_id) {
      this.load;

      let payload = {
        st_id: signage_type_id,
      };

      signageServices
        .GetSignageMovieMapping(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              let Obj = data.Records;
              this.Selectedsignagetype = Obj[0].signages_type;
              this.getSignageList(data.Records[0].signage_type_id);

              if (Obj[0].signages_type == "Movie") {
                data.Records.map((x) => {
                  this.getMovieList(x.movie_id);
                });
              }
              if (Obj[0].signages_type == "FnB") {
                data.Records.map((x) => {
                  this.GetFnbItems(x.fnb_item_id);
                });
              }
              if (Obj[0].signages_type == "Generic") {
                data.Records.map((x, index) => {
                  if (x.image_url != null) {
                    this.Url.push({
                      selected_url: x.image_url,
                      selected_type: "image",
                      smm_id: x.smm_id,
                      signage_type_id: x.signage_type_id,
                      uploadPercentage: 0,
                    });
                  }
                  if (x.video_url != null) {
                    this.Url.push({
                      selected_url: x.video_url,
                      selected_type: "video",
                      smm_id: x.smm_id,
                      signage_type_id: x.signage_type_id,
                      uploadPercentage: 0,
                    });
                  }
                });
              }

              this.smm_id = id;
              this.smm_is_active =
                data.Records[0].smm_is_active == "Y" ? true : false;
            }
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => this.load.hide(), 1000);
        });
    },
    getSignageList: function (st_id) {
      this.Signages = [];
      let payload = {
        tableName: "ms_signage_types",
        st_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Signages = data.Records;

            this.Signages.map((x) => {
              if (st_id == x.st_id) {
                this.signage_type_id = x.st_id;
                this.selected.Signage = x.st_name;
              }
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getMovieList: function (movie_id) {
      signageServices
        .GetMovieDetails()
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.Movielist = data.Records;

              this.Movielist.map((x) => {
                if (movie_id == x.movie_id) {
                  this.currentmovie_id.push({ movie_id: x.movie_id });
                  this.Movie.push(x);
                }
              });
            } else {
              console.log("show error :", data.message);
              // this.$toasted.show(data.message);
            }
          }
        })
        .catch(this._CatchError);
    },
    GetFnbItems: function (fnb_item_id) {
      this.FnbList = [];

      let payload = {
        cinema_id: this.cineID,
      };

      signageServices
        .GetFnBListSignages(payload)
        .then((response) => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              this.FnbItemList = data.Records;

              this.FnbItemList.map((x) => {
                if (fnb_item_id == x.fnb_item_id) {
                  this.currentmovie_id.push({ fnb_item_id: x.fnb_item_id });
                  this.SelectedFnbItems.push(x);
                }
              });
            }
          } else {
            console.log("show error :", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    toggleUnSelectMovie(removeitem) {
      this.removedmovie_id.push(removeitem);
    },
    toggleUnSelectFnB(removeitem) {
      this.removedmovie_id.push(removeitem);
    },
    onSelectHandler: function (data, type) {
      if (type == "Signage") {
        this.selected.Signage = data.st_name;
        this.signage_type_id = data.st_id;
      }
      if (type == "SignageType") {
        this.Selectedsignagetype = data.name;
      }
    },
    onResetForm: function () {
      this.selected.Signage = "";
      this.Movie = [];
      this.signage_type_id = null;
      this.smm_is_active = true;
      this.SelectedFnbItems = [];
    },

    addGeneric: function () {
      this.Url.push({
        selected_url: "",
        uploadPercentage: 0,
      });
    },
    removeGeneric: function (data, index) {
      this.removedmovie_id.push({
        smm_id: data.smm_id,
        signage_type_id: data.signage_type_id,
      });
      this.Url.splice(index, 1);
    },

    hideCropperModal: function (modal) {
      this.$bvModal.hide("imagecropper");
    },
    openImageModal: function (name, path, type) {
      this.tempModalImagePath = path;
      this.tempModalImageName = name;
      this.tempContentType = type;
      this.$refs["preview-modal"].show();
    },

    //Set Image
    setImage: function (e, index) {
      this.file = e.target.files[0];
      this.filename = e.target.files[0]["name"];
      this.indexofthubmnail = index;

      if (this.file.type.indexOf("image/") !== -1) {
        this.Url[index].selected_type = "image";

        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;
            this.width = 129;
            this.height = 192;
            // this.$cropper.setAspectRatio(1);
            // rebuild cropperjs with the updated source
            this.$bvModal.show("imagecropper");
            e.target.value = "";
          };
          reader.readAsDataURL(this.file);
        } else {
          // alert("Sorry, FileReader API not supported");
        }
      } else if (this.file.type.indexOf("video/") !== -1) {
        this.Url[index].selected_type = "video";

        this.load;

        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;

            this.VideoFilter();
            e.target.value = "";
          };
          reader.readAsDataURL(this.file);
        } else {
        }
      } else {
        this.$toasted.show("Please select an Image file OR Video File.");
        return;
      }
    },

    VideoFilter() {
      var block = this.imgSrc.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      this.OnVideoUpload(blob1, this.filename, this.indexofthubmnail);
    },

    cropImage() {
      this.$bvModal.hide("imagecropper");

      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      var block = this.cropImg.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      this.onThumbnailUpload(blob1, this.filename, this.indexofthubmnail);
    },

    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },

    OnVideoUpload: function (video, filename, index) {
      // let loader = this.$loading.show();
      this.load;

      let formData = new FormData();
      formData.append("video", video, filename);
      formData.append("videoPath", "Generic Signage");
      const options = {
        headers: {
          "content-type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
        },
        onUploadProgress: (event) => {
          const { loaded, total } = event;
          const percent = Math.floor((loaded / total) * 100);
          this.Url[index].uploadPercentage = percent;
        },
      };

      MasterService.GlobalUploadVideo(formData, options)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.Url[index].selected_url = data.path;
            this.imgSrc = "";
          } else {
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => this.load.hide(), 1000);
        });
    },

    onThumbnailUpload: function (image, filename, index) {
      this.load;

      let formData = new FormData();
      formData.append("image", image, filename);
      formData.append("imagePath", "Signage Image");
      let JWT = window.localStorage.getItem("JWT_TOKEN");
      const options = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: JWT,
          "Access-Control-Allow-Origin": "*",
        },
        onUploadProgress: (event) => {
          const { loaded, total } = event;
          const percent = Math.floor((loaded / total) * 100);
          this.Url[index].uploadPercentage = percent;
        },
      };
      MasterService.GlobalUploadImage(formData, options)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.Url[index].selected_url = data.path;
            this.imgSrc = "";
            this.$bvModal.hide("imagecropper");
          } else {
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => this.load.hide(), 1000);
        });
    },

    onFinalSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (this.selected.Signage.length == 0) {
          return;
        }
        if (this.Selectedsignagetype.length == 0) {
          return;
        }
        if (this.Selectedsignagetype == "Movie" && this.Movie.length == 0) {
          return;
        }
        if (
          this.Selectedsignagetype == "FnB" &&
          this.SelectedFnbItems.length == 0
        ) {
          return;
        }
        if (this.Selectedsignagetype == "Generic" && this.Url.length == 0) {
          return;
        } else {
          if (valid) {
            this.btenable = true;

            let payload = {
              smm_id: this.smm_id,
              signage_type_id: this.signage_type_id,
              SignageType: this.Selectedsignagetype,
              smm_is_active: this.smm_is_active,
              removedmovie_id: this.removedmovie_id,
            };

            if (this.Selectedsignagetype == "Movie") {
              payload["movie"] = this.Movie;
            }
            if (this.Selectedsignagetype == "FnB") {
              payload["fnb"] = this.SelectedFnbItems;
            }
            if (this.Selectedsignagetype == "Generic") {
              payload["generic"] = this.Url;
            }

            signageServices
              .UpdateSignageMovieMapping(payload)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data.status) {
                  if (flag) {
                    this.$router.push({
                      path: "/cinema-manager/signage-mapping",
                    });
                  } else {
                    this.submitted = false;
                  }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          }
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SignageMovieMappingComponents/editSignagemoviemapping.vue